<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ title }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="create">New</base-button>
          <base-button size="sm" type="neutral" v-b-modal.tracking-source-modal v-if="owner">
            <span class="btn-inner--icon"><i class="fas fa-chart-line"></i></span>
              <span class="btn-inner--text">New Category</span>
          </base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <community-tracking-table
        :title="title"
        :userRoute="userRoute"
        @updateItemsCount="updateItemsCount">  
      </community-tracking-table>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CommunityTrackingTable from '@/views/Components/Tables/CommunityTrackingTable';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  components: {
    RouteBreadCrumb,
    CommunityTrackingTable
  },
  data() {
    return {
      year: new Date().getFullYear(),
      itemsCount: 0,
    };
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium'
    }),
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
    title() {
      return this.year + ' Community Tracking';
    },
    owner() {
      const roles = this.$store.getters['roles/roles'];
      return roles[0] == 'owner';
    }
  },
  methods: {
    create() {
      if(this.subscribed || this.itemsCount < 25) {
        this.$router.push({path: '/communities/community-tracking/create'});
      } else {
        this.$bvModal.show('upgrade-modal');
      }
    },
    updateYear(year) {
      this.year = year;
    },
    updateItemsCount(count) {
      this.itemsCount = count;
    }
  },
  mounted() {
    document.title = this.title + " | ClarityNOW";
  }
};
</script>